import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import translationEN from "./locales/en.json";
import translationFI from "./locales/fi.json";

const resources = {
    en: {
        translation: translationEN
    },
    fi: {
        translation: translationFI
    }
}

const savedLanguage = typeof window !== "undefined"
  ? window.localStorage.getItem("portfolio-language")
  : null;

i18n.use(initReactI18next).init({
    resources,
    lng: savedLanguage === "en" ? "en" : "fi",
    fallbackLng: "fi",
    keySeparator: '.', // Allow for nested translations without using dots
    interpolation: {
      escapeValue: false,
    },
  });


export default i18n;
